import styled from '@emotion/styled';
import { css } from 'emotion';

export const EpisodeContentLabel = styled.h2`
  margin-bottom: 16px;
  color: #24203f;
  font-size: 2.4rem;
`;

export const UploaderStateContainer = styled.div<{
  containsMedia: boolean;
  isDragging: boolean;
}>`
  width: 100%;
  height: 100%;
  border: 1px ${({ isDragging }) => (isDragging ? '#5000B9' : '#dedfe0')}
    ${({ containsMedia }) => (containsMedia ? 'solid' : 'dashed')};
  border-radius: 8px;
  background: ${({ isDragging }) =>
    isDragging ? 'rgba(80, 0, 185, 0.03)' : '#ffffff'};
`;

export const ContentWrapper = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  padding: 20px 16px;
  text-align: left;
`;

export const UploaderContainer = styled.div`
  display: flex;
  width: 100%;
  @media (max-width: 940px) {
    display: block;
  }
`;

export const MediaInfoContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const UploaderContentsContainer = styled.div`
  width: 100%;
`;

export const UploaderLabelsContainer = styled.div`
  display: block;
  margin-left: 12px;
  overflow: hidden;
`;

export const UploaderStatusHeading = styled.h2`
  margin: 0 0 8px 0;
  color: #24203f;
  font-size: 1.8rem;
  line-height: 21px;
`;

export const UploaderStatusLabel = styled.div`
  color: #7f8287;
  font-size: 1.2rem;
  line-height: 14px;
`;

export const UploaderStatusContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-left: 6px;
  @media (max-width: 600px) {
    justify-content: center;
    padding: 12px 6px 0 6px;
  }
`;

export const uploaderCancelButtonStyle = css`
  width: 112px;
  height: 40px;
  color: #9a201c;
  @media (max-width: 600px) {
    width: 50%;
  }
`;

export const uploaderRetryButtonStyle = css`
  width: 106px;
  height: 40px;
  margin-left: 12px;
  color: #5000b9;
`;
